/**
 * 运行环境判断
 *
 * 同一份 H5 被两个入口复用，需要区分呈现：
 *   1. 浏览器直连（http://www.xiaodangjiacn.com:82 等）—— 甲方内部使用，保留原有全部文案
 *   2. 微信小程序 web-view（https://investor.xiaodangjiacn.com）—— 对外发布，
 *      需屏蔽「投资 / 股价 / 股份」等金融化表述
 *
 * 为什么要区分：小程序提审时，页面上的「今日股价 X 元/股」「投资额 X 元」「拥有股份 X 股」
 * 会被判定为金融（证券/股权）类业务，而微信「金融业」下所有二级类目都要求提供
 * 《经营证券期货业务许可证》等金融资质，本主体无法提供 → 直接拒审。
 * 详见 docs/小程序接入部署步骤.md 的「提审内容合规」一节。
 *
 * 重要：小程序端使用替代文案是**长期行为**，不是"只在审核时替换"。
 * 两个入口面向的人群本就不同（内部员工 vs 外部投资人），属于正常的产品差异化呈现。
 *
 * 判定优先级（任一命中即视为小程序端）：
 *   1. sessionStorage 中已固化的 env —— 首屏从 URL 读到后写入，路由跳转不丢
 *   2. URL query 上的 env=mp —— 由 miniprogram/pages/webview/index.js 显式携带
 *   3. UA 中的 miniProgram —— 微信 7.0.0+ web-view 的固定特征（新版还带小程序 appid）
 *   4. window.__wxjs_environment === 'miniprogram' —— 微信注入的环境变量，兜底
 */

const ENV_KEY = '__xdj_env__';

/** 小程序端标识值 */
const MP = 'mp';

/**
 * 首屏调用一次，把 URL 上的 env 固化到 sessionStorage。
 *
 * 必须这么做：vue-router 是 history 模式，跳转后会丢掉 query，
 * 不固化的话用户点一次菜单就"退回"浏览器版文案了。
 */
export function initEnv() {
  try {
    const env = new URLSearchParams(window.location.search).get('env');
    if (env) {
      sessionStorage.setItem(ENV_KEY, env);
    }
  } catch (e) {
    // 隐私模式 / 极老浏览器下 sessionStorage 可能抛异常，忽略即可
  }
}

/** 是否运行在微信小程序 web-view 容器内 */
export function isMiniProgram() {
  try {
    if (sessionStorage.getItem(ENV_KEY) === MP) return true;
  } catch (e) {
    /* ignore */
  }

  try {
    if (new URLSearchParams(window.location.search).get('env') === MP) return true;
  } catch (e) {
    /* ignore */
  }

  if (/miniProgram/i.test(navigator.userAgent || '')) return true;

  return window.__wxjs_environment === 'miniprogram';
}
